import { Brand } from "./brand";
import { KeyedMetrics } from "./keyedMetrics";
import { Metric } from "./metric";

export class MetricsByBrand extends KeyedMetrics {
    get brands(): Brand[] {
        return this.keys as Brand[];
    }

    getTotalForBrands(brands: Brand[]): number {
        return this.getTotalForKeys(brands);
    }

    getMetricForBrand(brand: Brand): Metric {
        return this.getMetricForKey(brand);
    }

    setMetricForBrand(brand: Brand, metric: Metric) {
        this.setMetricForKey(brand, metric);
    }

    setMetricForBrandNamed(brandName: string, metric: Metric) {
        this.setMetricForKey(Brand.brandWithName(brandName), metric);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/model/metricsByBrand.ts